import React, { useState, useEffect } from "react";
import { Image } from "react-bootstrap";

/**
 * A component for searching within a DataTable.
 *
 * @component
 * @param {Object} props
 * @param {Object} props.query - Current table query state (page, pageSize, search, sort).
 * @param {Function} props.setQuery - Function to update the query state.
 *
 * @example
 * <DataTableSearch
 *   query={query}
 *   setQuery={setQuery}
 * />
 */
const DataTableSearch = ({ query, setQuery, filterElement, actionElement }) => {
  const [term, setTerm] = useState(query.search);

  useEffect(() => {
    const delay = setTimeout(() => {
      setQuery((prev) => ({ ...prev, search: term, page: 1 }));
    }, 300);
    return () => clearTimeout(delay);
  }, [term, setQuery]);

  return (
    <>
      <div className="d-flex align-items-center mb-3 justify-content-between px-4">
        <div
          className="mb-3 position-relative bg-transparent text-color font-13 font-weight-normal"
          style={{
            width: "296px",
            border: "1px solid #CFD1D0",
            borderRadius: "8px",
            padding: "10px 12px",
          }}
        >
          <input
            type="text"
            placeholder="Search here..."
            className="bg-transparent border-0 text-color font-13 font-weight-normal"
            value={term}
            onChange={(e) => setTerm(e.target.value)}
            style={{
              paddingLeft: "25px",
              width: "100%",
            }}
          />
          <Image
            src="/assets/images/search-icon.svg"
            alt="Search"
            width={16}
            height={16}
            className="position-absolute"
            style={{
              top: "50%",
              left: "10px",
              transform: "translateY(-50%)",
              pointerEvents: "none",
            }}
          />
        </div>
        <div className="d-flex align-items-center gap-3">
          <div>{filterElement}</div>
          {actionElement && (
            <div className="action-element">{actionElement}</div>
          )}
        </div>
      </div>
    </>
  );
};

export default DataTableSearch;
